/**
 * Renders the display value for a service attribute based on its type
 * @param attribute - The attribute object containing value, type, and unit information
 * @returns Formatted string representation of the attribute value
 */
export const renderAttributeValue = (attribute: any): string => {
  switch (attribute.type) {
    case 1: // Range with unit
    case 3: // Numeric (can be single or range)
      // Check for one-off unit - don't show value for one-off
      if (
        attribute.unitValue &&
        attribute.unitValue.toLowerCase().trim() === "one-off"
      ) {
        return "one-off";
      }

      const hasSingleValue =
        attribute.value !== null &&
        attribute.value !== undefined &&
        attribute.value !== 0;
      const hasMinValue =
        attribute.minValue !== null &&
        attribute.minValue !== undefined &&
        attribute.minValue !== 0;
      const hasMaxValue =
        attribute.maxValue !== null &&
        attribute.maxValue !== undefined &&
        attribute.maxValue !== 0;
      const hasRange = hasMinValue || hasMaxValue;

      if (hasSingleValue && !hasRange) {
        // Single value mode
        const unit = attribute.unitValue?.trim() || attribute.unit || "";
        return `${attribute.value}${unit ? " " + unit : ""}`;
      } else if (hasRange && !hasSingleValue) {
        // Range mode
        const minVal = attribute.minValue || 0;
        const maxVal = attribute.maxValue || 0;
        const unit = attribute.unitValue?.trim() || attribute.unit || "";
        return `${minVal} - ${maxVal}${unit ? " " + unit : ""}`;
      }
      return "";

    case 2: // Text input
    case 6: // List selection
      return attribute.textValue || "";

    case 4: // Time
    case 5: // Time range
    case 7: // Period range
      const hasTimeValue =
        attribute.value !== null &&
        attribute.value !== undefined &&
        attribute.value !== 0;
      const hasTimeMinValue =
        attribute.minValue !== null &&
        attribute.minValue !== undefined &&
        attribute.minValue !== 0;
      const hasTimeMaxValue =
        attribute.maxValue !== null &&
        attribute.maxValue !== undefined &&
        attribute.maxValue !== 0;
      const hasTimeRange = hasTimeMinValue || hasTimeMaxValue;

      if (hasTimeValue && !hasTimeRange) {
        // Single time value
        const unit = attribute.unitValue?.trim() || "";
        return `${attribute.value}${unit ? " " + unit : ""}`;
      } else if (hasTimeRange && !hasTimeValue) {
        // Time range
        const minVal = attribute.minValue || 0;
        const maxVal = attribute.maxValue || 0;
        const unit = attribute.unitValue?.trim() || "";
        return `${minVal} - ${maxVal}${unit ? " " + unit : ""}`;
      }
      return "";

    default:
      return "";
  }
};
